import { SITE_URL, buildMetadata } from "@/lib/seo/metadata";

export const siteConfig = {
  name: "SDPSI Formations",
  shortName: "SDPSI",
  title: "SDPSI Formations | Santé, sécurité et prévention au travail",
  description:
    "Organisme de formation professionnelle en santé, sécurité et prévention des risques. Formations SST, incendie, habilitations et risques spécifiques.",
  url: SITE_URL,
  locale: "fr_FR",
  contact: {
    email: "sdpsiformation@orange.fr",
    phoneDisplay: "06.22.61.04.09",
    phoneHref: "0622610409",
    addressLine1: "2 bis Rue de la Venellerie",
    postalCode: "27220",
    city: "Bois-le-Roi",
    country: "France",
  },
  social: {
    linkedin: "https://linkedin.com/company/sdpsi-formation",
    facebook: "https://facebook.com/sdpsiformation",
  },
  legal: {
    siret: process.env.NEXT_PUBLIC_LEGAL_SIRET || "Non communique",
    nda: process.env.NEXT_PUBLIC_LEGAL_NDA || "Non communique",
  },
  images: {
    logo: "/images/home/sdpsilogo.png",
    og: "/sdpsi.png",
  },
  keywords: [
    "formation sécurité",
    "formation SST",
    "prévention des risques",
    "habilitation électrique",
    "formation incendie",
    "SDPSI Formation",
  ],
} as const;

export { buildMetadata };
